// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import "preline/dist/preline.js";
import "./controllers";

function addMultipleEventListeners(element, events, handler, options) {
  events.forEach((event) => element.addEventListener(event, handler, options));
}

addMultipleEventListeners(
  document,
  ["turbo:before-stream-render", "turbo:load"],
  (e) => {
    setTimeout(() => {
      HSAccordion.autoInit();
      HSDropdown.autoInit();
      HSOverlay.autoInit();
      HSSelect.autoInit();
      HSTooltip.autoInit();
      HSRemoveElement.autoInit();
      HSCollapse.autoInit();
      HSTabs.autoInit();

      document.body.addEventListener('click', function(event) {
        // Check if the click originated from an <a> tag or interactive element
        const interactiveElement = event.target.closest('a, button, [role="button"], input, select, textarea, [contenteditable]');

        // If clicked on an interactive element that has an href, let it handle its own behavior
        if (interactiveElement && (interactiveElement.hasAttribute('href') || interactiveElement.tagName === 'A')) {
          // Allow middle-click (button 1) to open in new tab for links
          if (event.button === 1 && interactiveElement.tagName === 'A') {
            event.preventDefault();
            window.open(interactiveElement.href, '_blank', 'noopener, noreferrer');
          }
          return;
        }

        // Find the closest data-href element (table row or other)
        const dataHrefElement = event.target.closest('[data-href]');

        if (dataHrefElement) {
          const href = dataHrefElement.getAttribute('data-href');
          if (!href) return;

          event.preventDefault();

          // Handle different click types
          if (event.metaKey || event.ctrlKey || event.button === 1) {
            // Middle click or Ctrl/Cmd + click - open in new tab
            window.open(href, '_blank', 'noopener, noreferrer');
          } else if (event.button === 0) {
            // Regular left click - navigate to URL
            window.location.href = href;
          }
        }
      });
    }, 50);
  },
);